// import React, { useState } from "react";
// import { useContent } from "contexts/contentContext/contentContext.js";
// import Button from "components/Elements/Button/Button.js";
// import { LinkToNewTab } from "components/Elements/Link/Link.js";
// import CheckboxElement from "components/Elements/CheckboxElement/CheckboxElement.js";
// import InputElement from "components/Elements/InputElement/InputElement.js";
// import apiRequest from "utils/ApiRequest/apiRequest.js";
// import { useUser } from "contexts/userContext/userContext.js";
// import { useToasts } from "react-toast-notifications";
// import parse from "html-react-parser";
// import GetTransformedDate from "utils/dateViewTransformer.tsx";
// import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
// import CancelSubscriptionOptions from "./CancelSubscriptionOptions/CancelSubscriptionRadioOptions.tsx";

// const CancelSubscriptionSideElement = ({
//   setShowElement,
//   setUserIsAutoRenew,
// }) => {
//   const [elementStep, setElementStep] = useState(1);
//   const [cancelType, setCancelType] = useState("stop-renewal");
//   const elementSteps = {
//     1: (
//       <CancelSubscriptionStep1
//         setElementStep={setElementStep}
//         setShowElement={setShowElement}
//         setCancelType={setCancelType}
//         cancelType={cancelType}
//       />
//     ),
//     2: (
//       <CancelSubscriptionStep2
//         setElementStep={setElementStep}
//         setUserIsAutoRenew={setUserIsAutoRenew}
//         cancelType={cancelType}
//       />
//     ),
//     3: (
//       <CancelSubscriptionStep3
//         setShowElement={setShowElement}
//         cancelType={cancelType}
//       />
//     ),
//   };
//   return (
//     <div className="cancel-subscription-element">
//       <div className="cancel-subscription-element-container">
//         {elementSteps[elementStep]}
//       </div>
//     </div>
//   );
// };

// export default CancelSubscriptionSideElement;

// export const CheckAddonExist = (subscription) => {
//   let response = {
//     total_active: 0,
//     has_active: false,
//     sub_users: false,
//     extra_storage: false,
//   };
//   if (subscription.addons && subscription.addons.length > 0) {
//     const active_addon = subscription.addons.filter(
//       (addon) => addon.status == 1
//     );
//     response.total_active = active_addon.length;
//     response.has_active = active_addon.length > 0;
//     response.sub_users = active_addon.some(
//       (addon) => addon.name === "sub-users"
//     );
//     response.extra_storage = active_addon.some(
//       (addon) => addon.name === "extra-storage"
//     );
//   }
//   return response;
// };
// //Step 1:
// export const CancelSubscriptionStep1 = ({
//   setElementStep,
//   setShowElement,
//   setCancelType,
//   cancelType,
// }) => {
//   const { getTextByKey, getDirection } = useContent();
//   const { getUserBillingDetails } = useUser();
//   const userBillingDetails = getUserBillingDetails();
//   const existsAddons = CheckAddonExist(userBillingDetails);

//   const notAutoRenewSubscription = userBillingDetails?.auto_renew === false;
//   const autoRenewSubscription = !notAutoRenewSubscription;
//   const { addToast } = useToasts();

//   const continueToStep2 = () => {
//     if (autoRenewSubscription) {
//       if (!existsAddons.has_active) {
//         setElementStep(2);
//       } else {
//         addToast(getTextByKey("delete-addons-first"), {
//           appearance: "error",
//         });
//       }
//     } else {
//       addToast(getTextByKey("cannot-cancel-subscription"), {
//         appearance: "error",
//       });
//     }
//   };

//   return (
//     <div className="cancel-subscription-element-step">
//       <div className="cancel-subscription-element-step-container">
//         <div className="cancel-subscription-element-step-header">
//           <h2>{getTextByKey("cancel-your-subscription")}</h2>
//         </div>
//         <div className="cancel-subscription-element-step-body">
//           <div className="cancel-subscription-element-side-section">
//             <div
//               className={`side-border orange-border ${
//                 getDirection() === "rtl" ? "side-border-rtl" : ""
//               }`}
//             ></div>
//             <h3>{getTextByKey("issue-question-cancel-subscription")}</h3>
//             <p>
//               {getTextByKey("cancel-your-subscription-step1-contact-us-text")}
//             </p>
//             <Button className="new-button orange-blank" blank>
//               <LinkToNewTab page="contact-us" isNewTab>
//                 {getTextByKey("contact-us")}
//               </LinkToNewTab>
//             </Button>
//           </div>
//           <div className="cancel-subscription-element-side-section">
//             <div
//               className={`side-border blue-border ${
//                 getDirection() === "rtl" ? "side-border-rtl" : ""
//               }`}
//             ></div>
//             <h3>{getTextByKey("try-different-plans-title")}</h3>
//             <p>{getTextByKey("try-different-plans-text")}</p>
//             <Button className="new-button" blank>
//               <LinkToNewTab page="plans" isNewTab>
//                 {getTextByKey("profileuser-change-plan-link")}
//               </LinkToNewTab>
//             </Button>
//           </div>
//           <CancelSubscriptionOptions
//             cancelType={cancelType}
//             setCancelType={setCancelType}
//           />
//         </div>
//         <div className="cancel-subscription-element-step-actions">
//           <Button
//             className="new-button"
//             blank
//             onClick={() => setShowElement(false)}
//           >
//             {getTextByKey("close")}
//           </Button>
//           {!existsAddons.has_active && (
//             <Button className="new-button" onClick={() => continueToStep2()}>
//               {getTextByKey("check-status-button")}
//             </Button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// //Step 2 (Questions):
// export const CancelSubscriptionStep2 = ({
//   setElementStep,
//   setUserIsAutoRenew,
//   cancelType,
// }) => {
//   const { getTextByKey, getDirection } = useContent();
//   const { getUserData } = useUser();
//   const userData = getUserData();
//   const { addToast } = useToasts();
//   const [selectedCheckboxsList, setSelectedCheckboxsList] = useState([]); //Question 1
//   const [whichFileTransferUsing, setWhichFileTransferUsing] = useState("");
//   const [whatCanWeDoBetter, setWhatCanWeDoBetter] = useState("");
//   const [followUpUser, setFollowUpUser] = useState(true);
//   const addOrRemoveChackbox = (checkbox) => {
//     const newSelectedCheckboxsList = [...selectedCheckboxsList];
//     if (newSelectedCheckboxsList.includes(checkbox)) {
//       newSelectedCheckboxsList.splice(
//         newSelectedCheckboxsList.indexOf(checkbox),
//         1
//       );
//     } else {
//       newSelectedCheckboxsList.push(checkbox);
//     }
//     setSelectedCheckboxsList(newSelectedCheckboxsList);
//   };
//   const [isCancellingSubscription, setIsCancellingSubscription] =
//     useState(false);

//   const questionsList = [
//     {
//       question: getTextByKey("why-are-you-cancelling-your-subscription"),
//       questionType: "checkbox",
//       checkboxList: [
//         {
//           text: getTextByKey("free-service-is-enough"),
//           systemName: "free-service-is-enough",
//         },
//         {
//           text: getTextByKey("support-was-unsatisfactory"),
//           systemName: "support-was-unsatisfactory",
//         },
//         {
//           text: getTextByKey("it-was-difficult-to-use"),
//           systemName: "it-was-difficult-to-use",
//         },
//         {
//           text: getTextByKey("i-had-technical-issues"),
//           systemName: "i-had-technical-issues",
//         },
//         {
//           text: getTextByKey("it-lacks-key-features"),
//           systemName: "it-lacks-key-features",
//         },
//         {
//           text: getTextByKey("found-better-solution"),
//           systemName: "found-better-solution",
//         },
//         {
//           text: getTextByKey("too-expensive"),
//           systemName: "too-expensive",
//         },
//         {
//           text: getTextByKey("was-test-account"),
//           systemName: "was-test-account",
//         },
//         {
//           text: getTextByKey("other"),
//           systemName: "other",
//         },
//       ],
//     },
//     {
//       question: getTextByKey("which-file-transfers-are-you-using"),
//       questionType: "input",
//       state: whichFileTransferUsing,
//       setState: setWhichFileTransferUsing,
//     },
//     {
//       question: getTextByKey("what-can-we-do-better"),
//       questionType: "textarea",
//       state: whatCanWeDoBetter,
//       setState: setWhatCanWeDoBetter,
//     },
//   ];

//   const cancelSubscription = async () => {
//     setIsCancellingSubscription(true);
//     const bodyRequest = {
//       CancelSubscriptionSurveyUserId: userData.UserId,
//       WhyCancelingReasons: selectedCheckboxsList,
//       WhichFileTransferUsing: whichFileTransferUsing,
//       WhatCanWeDoBetter: whatCanWeDoBetter,
//       FollowUpUser: followUpUser,
//       CancelType: cancelType, // stop-renewal or cancel-immediately
//     };
//     console.log(bodyRequest);
//     // await createCancelSubscriptionSurvey(bodyRequest);
//     setIsCancellingSubscription(false);
//     setElementStep(3);
//   };

//   const createCancelSubscriptionSurvey = async (body) => {
//     const response = await apiRequest(
//       "Users",
//       "CreateCancelSubscriptionSurvey",
//       body,
//       "POST"
//     );
//     console.log("res", response);
//     if (response.status === "success" && response.data) {
//       setUserIsAutoRenew(false);
//     } else {
//       const textToShow = response.data
//         ? response.data
//         : "cancel-subscription-global-error";
//       addToast(getTextByKey(textToShow), {
//         appearance: "error",
//       });
//     }
//   };

//   return (
//     <div className="cancel-subscription-element-step">
//       <div className="cancel-subscription-element-step-container">
//         <div className="cancel-subscription-element-step-header">
//           <h2>{getTextByKey("cancel-your-subscription")}</h2>
//         </div>
//         <div className="cancel-subscription-element-step-body">
//           <div className="cancel-subscription-element-side-section top">
//             {parse(getTextByKey("cancel-your-subscription-step2-text"))}
//           </div>
//           <div className="cancel-subscription-element-side-section">
//             {questionsList.map((question, index) => (
//               <div
//                 key={index}
//                 className={`cancel-subscription-element-question ${
//                   getDirection() === "rtl" ? "rtl" : ""
//                 }`}
//               >
//                 <h3>{question.question}</h3>
//                 {question.questionType === "checkbox" ? (
//                   <div className="cancel-subscription-element-checkbox-list">
//                     {question.checkboxList.map((checkbox, index) => (
//                       <CheckboxElement
//                         key={index}
//                         checkboxLabel={checkbox.text}
//                         state={selectedCheckboxsList.includes(
//                           checkbox.systemName
//                         )}
//                         setState={() =>
//                           addOrRemoveChackbox(checkbox.systemName)
//                         }
//                       />
//                     ))}
//                   </div>
//                 ) : (
//                   <InputElement
//                     state={question.state}
//                     setState={question.setState}
//                     isTextArea={question.questionType === "textarea"}
//                   />
//                 )}
//               </div>
//             ))}
//             <CheckboxElement
//               checkboxLabel={getTextByKey(
//                 "cancel-your-subscription-step2-follow-up"
//               )}
//               state={followUpUser}
//               setState={() => setFollowUpUser(!followUpUser)}
//             />
//             <div className="thank-you-part">
//               <p>{getTextByKey("cancel-subscription-thank-you")}</p>
//             </div>
//           </div>
//         </div>
//         <div className="cancel-subscription-element-step-actions">
//           <Button
//             className="new-button"
//             blank
//             onClick={() => setElementStep(1)}
//           >
//             {getTextByKey("check-status-button-back")}
//           </Button>
//           <Button
//             className="new-button"
//             onClick={() => cancelSubscription()}
//             disabled={isCancellingSubscription}
//           >
//             {isCancellingSubscription ? (
//               <LoadingImageElement />
//             ) : (
//               getTextByKey("cancel-my-subscription")
//             )}
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Step 3
// export const CancelSubscriptionStep3 = ({ setShowElement, cancelType }) => {
//   const { getTextByKey } = useContent();
//   const { getUserBillingDetails } = useUser();
//   const billingDetails = getUserBillingDetails();

//   const isCancelImmediately = cancelType !== "stop-renewal";

//   const calculateNextBillingDate = () => {
//     //if the user is RenewableSubsciber, need to display the next billing date
//     if (billingDetails?.nextPaymentDate) {
//       return billingDetails?.nextPaymentDate;
//     }

//     const isYearly = billingDetails?.period === 12 ? true : false;
//     const lastPaymentDate = billingDetails?.LastPaymentDate;

//     if (isYearly) {
//       return new Date(
//         new Date(lastPaymentDate).getFullYear() + 1,
//         new Date(lastPaymentDate).getMonth(),
//         new Date(lastPaymentDate).getDate()
//       );
//     } else {
//       return new Date(
//         new Date(lastPaymentDate).getFullYear(),
//         new Date(lastPaymentDate).getMonth() + 1,
//         new Date(lastPaymentDate).getDate()
//       );
//     }
//   };

//   const replaceText = (textKey) => {
//     const text = getTextByKey(textKey);

//     const date = isCancelImmediately
//       ? new Date(new Date().setDate(new Date().getDate() + 3))
//       : calculateNextBillingDate();
//     const dateFormat = GetTransformedDate({
//       date,
//       fullView: true,
//       showDay: false,
//     });
//     const newText = text.replace("#date#", dateFormat);
//     return newText;
//   };

//   return (
//     <div className="cancel-subscription-element-step">
//       <div className="cancel-subscription-element-step-container">
//         <div className="cancel-subscription-element-step-header">
//           <h2>{getTextByKey("subscription-cancel-confirmation")}</h2>
//         </div>
//         <div className="cancel-subscription-element-step-body">
//           <div className="cancel-subscription-element-side-section top">
//             {parse(
//               replaceText(
//                 isCancelImmediately
//                   ? "canceled-subscription-immediately-text"
//                   : "canceled-subscription-renewal-text"
//               )
//             )}
//           </div>
//         </div>
//         <div className="cancel-subscription-element-step-actions">
//           <Button
//             className="new-button"
//             blank
//             onClick={() => setShowElement(false)}
//           >
//             {getTextByKey("close")}
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

import React, { useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Button from "components/Elements/Button/Button.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import CheckboxElement from "components/Elements/CheckboxElement/CheckboxElement.js";
import InputElement from "components/Elements/InputElement/InputElement.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useToasts } from "react-toast-notifications";
import parse from "html-react-parser";
import GetTransformedDate from "utils/dateViewTransformer.tsx";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";

const CancelSubscriptionSideElement = ({
  setShowElement,
  setUserIsAutoRenew,
}) => {
  const [elementStep, setElementStep] = useState(1);
  const elementSteps = {
    1: (
      <CancelSubscriptionStep1
        setElementStep={setElementStep}
        setShowElement={setShowElement}
      />
    ),
    2: (
      <CancelSubscriptionStep2
        setElementStep={setElementStep}
        setUserIsAutoRenew={setUserIsAutoRenew}
      />
    ),
    3: <CancelSubscriptionStep3 setShowElement={setShowElement} />,
  };
  return (
    <div className="cancel-subscription-element">
      <div className="cancel-subscription-element-container">
        {elementSteps[elementStep]}
      </div>
    </div>
  );
};

export default CancelSubscriptionSideElement;

export const CheckAddonExist = (subscription) => {
  let response = {
    total_active: 0,
    has_active: false,
    sub_users: false,
    extra_storage: false,
  };
  if (subscription.addons && subscription.addons.length > 0) {
    const active_addon = subscription.addons.filter(
      (addon) => addon.status == 1
    );
    response.total_active = active_addon.length;
    response.has_active = active_addon.length > 0;
    response.sub_users = active_addon.some(
      (addon) => addon.name === "sub-users"
    );
    response.extra_storage = active_addon.some(
      (addon) => addon.name === "extra-storage"
    );
  }
  return response;
};
//Step 1:
export const CancelSubscriptionStep1 = ({ setElementStep, setShowElement }) => {
  const { getTextByKey, getDirection } = useContent();
  const { getUserBillingDetails } = useUser();
  const userBillingDetails = getUserBillingDetails();
  const existsAddons = CheckAddonExist(userBillingDetails);

  const notAutoRenewSubscription = userBillingDetails?.auto_renew === false;
  const autoRenewSubscription = !notAutoRenewSubscription;
  const { addToast } = useToasts();

  const continueToStep2 = () => {
    if (autoRenewSubscription) {
      if (!existsAddons.has_active) {
        setElementStep(2);
      } else {
        addToast(getTextByKey("delete-addons-first"), {
          appearance: "error",
        });
      }
    } else {
      addToast(getTextByKey("cannot-cancel-subscription"), {
        appearance: "error",
      });
    }
  };

  const fixDisplayFirstStepText = (text) => {
    let newText = text;
    //replcae the text with the correct text
    const replceSubUsersConst = "#exists-sub-users#";
    const replaceExtraStorageConst = "#exists-extra-storage#";
    //if existsSubUsers is true, replace the text with the correct text else remove the text (replace with empty string)
    if (text.includes(replceSubUsersConst)) {
      if (existsAddons.sub_users) {
        newText = newText.replace(
          replceSubUsersConst,
          `<strong>${getTextByKey("exists-sub-users-text")}</strong><br>`
        );
      } else {
        newText = newText.replace(replceSubUsersConst, "");
      }
    }

    if (text.includes(replaceExtraStorageConst)) {
      newText = newText.replace(
        replaceExtraStorageConst,
        existsAddons.extra_storage
          ? `<strong>${getTextByKey("exists-extra-storage-text")}</strong><br>`
          : ""
      );
    }

    return newText;
  };
  return (
    <div className="cancel-subscription-element-step">
      <div className="cancel-subscription-element-step-container">
        <div className="cancel-subscription-element-step-header">
          <h2>{getTextByKey("cancel-your-subscription")}</h2>
        </div>
        <div className="cancel-subscription-element-step-body">
          <div className="cancel-subscription-element-side-section top">
            {parse(
              fixDisplayFirstStepText(
                getTextByKey(
                  existsAddons.has_active
                    ? "cancel-your-subscription-step1-addons-text"
                    : "cancel-your-subscription-step1-text"
                )
              )
            )}
            {existsAddons.sub_users ? (
              <p className="addon-link">
                {parse(getTextByKey("exists-sub-users"))}
              </p>
            ) : null}
            {existsAddons.extra_storage ? (
              <p className="addon-link">
                {parse(getTextByKey("exists-extra-storage"))}
              </p>
            ) : null}
          </div>
          <div className="cancel-subscription-element-side-section">
            <div
              className={`side-border orange-border ${
                getDirection() === "rtl" ? "side-border-rtl" : ""
              }`}
            ></div>
            <h3>{getTextByKey("issue-question-cancel-subscription")}</h3>
            <p>
              {getTextByKey("cancel-your-subscription-step1-contact-us-text")}
            </p>
            <Button className="new-button orange-blank" blank>
              <LinkToNewTab page="contact-us" isNewTab>
                {getTextByKey("contact-us")}
              </LinkToNewTab>
            </Button>
          </div>
          <div className="cancel-subscription-element-side-section">
            <div
              className={`side-border blue-border ${
                getDirection() === "rtl" ? "side-border-rtl" : ""
              }`}
            ></div>
            <h3>{getTextByKey("try-different-plans-title")}</h3>
            <p>{getTextByKey("try-different-plans-text")}</p>
            <Button className="new-button" blank>
              <LinkToNewTab page="plans" isNewTab>
                {getTextByKey("profileuser-change-plan-link")}
              </LinkToNewTab>
            </Button>
          </div>
        </div>
        <div className="cancel-subscription-element-step-actions">
          <Button
            className="new-button"
            blank
            onClick={() => setShowElement(false)}
          >
            {getTextByKey("close")}
          </Button>
          {!existsAddons.has_active && (
            <Button className="new-button" onClick={() => continueToStep2()}>
              {getTextByKey("check-status-button")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

//Step 2 (Questions):
export const CancelSubscriptionStep2 = ({
  setElementStep,
  setUserIsAutoRenew,
}) => {
  const { getTextByKey, getDirection } = useContent();
  const { getUserData } = useUser();
  const userData = getUserData();
  const { addToast } = useToasts();
  const [selectedCheckboxsList, setSelectedCheckboxsList] = useState([]); //Question 1
  const [whichFileTransferUsing, setWhichFileTransferUsing] = useState("");
  const [whatCanWeDoBetter, setWhatCanWeDoBetter] = useState("");
  const [followUpUser, setFollowUpUser] = useState(true);
  const addOrRemoveChackbox = (checkbox) => {
    const newSelectedCheckboxsList = [...selectedCheckboxsList];
    if (newSelectedCheckboxsList.includes(checkbox)) {
      newSelectedCheckboxsList.splice(
        newSelectedCheckboxsList.indexOf(checkbox),
        1
      );
    } else {
      newSelectedCheckboxsList.push(checkbox);
    }
    setSelectedCheckboxsList(newSelectedCheckboxsList);
  };
  const [isCancellingSubscription, setIsCancellingSubscription] =
    useState(false);

  const questionsList = [
    {
      question: getTextByKey("why-are-you-cancelling-your-subscription"),
      questionType: "checkbox",
      checkboxList: [
        {
          text: getTextByKey("free-service-is-enough"),
          systemName: "free-service-is-enough",
        },
        {
          text: getTextByKey("support-was-unsatisfactory"),
          systemName: "support-was-unsatisfactory",
        },
        {
          text: getTextByKey("it-was-difficult-to-use"),
          systemName: "it-was-difficult-to-use",
        },
        {
          text: getTextByKey("i-had-technical-issues"),
          systemName: "i-had-technical-issues",
        },
        {
          text: getTextByKey("it-lacks-key-features"),
          systemName: "it-lacks-key-features",
        },
        {
          text: getTextByKey("found-better-solution"),
          systemName: "found-better-solution",
        },
        {
          text: getTextByKey("too-expensive"),
          systemName: "too-expensive",
        },
        {
          text: getTextByKey("was-test-account"),
          systemName: "was-test-account",
        },
        {
          text: getTextByKey("other"),
          systemName: "other",
        },
      ],
    },
    {
      question: getTextByKey("which-file-transfers-are-you-using"),
      questionType: "input",
      state: whichFileTransferUsing,
      setState: setWhichFileTransferUsing,
    },
    {
      question: getTextByKey("what-can-we-do-better"),
      questionType: "textarea",
      state: whatCanWeDoBetter,
      setState: setWhatCanWeDoBetter,
    },
  ];

  const cancelSubscription = async () => {
    setIsCancellingSubscription(true);
    const bodyRequest = {
      CancelSubscriptionSurveyUserId: userData.UserId,
      WhyCancelingReasons: selectedCheckboxsList,
      WhichFileTransferUsing: whichFileTransferUsing,
      WhatCanWeDoBetter: whatCanWeDoBetter,
      FollowUpUser: followUpUser,
    };
    await createCancelSubscriptionSurvey(bodyRequest);
    setIsCancellingSubscription(false);
    setElementStep(3);
  };

  const createCancelSubscriptionSurvey = async (body) => {
    const response = await apiRequest(
      "Users",
      "CreateCancelSubscriptionSurvey",
      body,
      "POST"
    );
    console.log("res", response);
    if (response.status === "success" && response.data) {
      setUserIsAutoRenew(false);
    } else {
      const textToShow = response.data
        ? response.data
        : "cancel-subscription-global-error";
      addToast(getTextByKey(textToShow), {
        appearance: "error",
      });
    }
  };

  return (
    <div className="cancel-subscription-element-step">
      <div className="cancel-subscription-element-step-container">
        <div className="cancel-subscription-element-step-header">
          <h2>{getTextByKey("cancel-your-subscription")}</h2>
        </div>
        <div className="cancel-subscription-element-step-body">
          <div className="cancel-subscription-element-side-section top">
            {parse(getTextByKey("cancel-your-subscription-step2-text"))}
          </div>
          <div className="cancel-subscription-element-side-section">
            {questionsList.map((question, index) => (
              <div
                key={index}
                className={`cancel-subscription-element-question ${
                  getDirection() === "rtl" ? "rtl" : ""
                }`}
              >
                <h3>{question.question}</h3>
                {question.questionType === "checkbox" ? (
                  <div className="cancel-subscription-element-checkbox-list">
                    {question.checkboxList.map((checkbox, index) => (
                      <CheckboxElement
                        key={index}
                        checkboxLabel={checkbox.text}
                        state={selectedCheckboxsList.includes(
                          checkbox.systemName
                        )}
                        setState={() =>
                          addOrRemoveChackbox(checkbox.systemName)
                        }
                      />
                    ))}
                  </div>
                ) : (
                  <InputElement
                    state={question.state}
                    setState={question.setState}
                    isTextArea={question.questionType === "textarea"}
                  />
                )}
              </div>
            ))}
            <CheckboxElement
              checkboxLabel={getTextByKey(
                "cancel-your-subscription-step2-follow-up"
              )}
              state={followUpUser}
              setState={() => setFollowUpUser(!followUpUser)}
            />
            <div className="thank-you-part">
              <p>{getTextByKey("cancel-subscription-thank-you")}</p>
            </div>
          </div>
        </div>
        <div className="cancel-subscription-element-step-actions">
          <Button
            className="new-button"
            blank
            onClick={() => setElementStep(1)}
          >
            {getTextByKey("check-status-button-back")}
          </Button>
          <Button
            className="new-button"
            onClick={() => cancelSubscription()}
            disabled={isCancellingSubscription}
          >
            {isCancellingSubscription ? (
              <LoadingImageElement />
            ) : (
              getTextByKey("cancel-my-subscription")
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

// Step 3
export const CancelSubscriptionStep3 = ({ setShowElement }) => {
  const { getTextByKey } = useContent();
  const { getUserBillingDetails, getUserData } = useUser();
  const userData = getUserData();
  const billingDetails = getUserBillingDetails();
  const calculateNextBillingDate = () => {
    //if the user is RenewableSubsciber, need to display the next billing date
    if (billingDetails?.nextPaymentDate) {
      return billingDetails?.nextPaymentDate;
    }

    const isYearly = billingDetails?.period === 12 ? true : false;
    const lastPaymentDate = billingDetails?.LastPaymentDate;

    if (isYearly) {
      return new Date(
        new Date(lastPaymentDate).getFullYear() + 1,
        new Date(lastPaymentDate).getMonth(),
        new Date(lastPaymentDate).getDate()
      );
    } else {
      return new Date(
        new Date(lastPaymentDate).getFullYear(),
        new Date(lastPaymentDate).getMonth() + 1,
        new Date(lastPaymentDate).getDate()
      );
    }
  };

  const replaceText = (text) => {
    const date = calculateNextBillingDate();
    const dateFormat = GetTransformedDate({
      date,
      fullView: true,
      showDay: false,
    });
    let newText = text.replace("#next-payment-date#", dateFormat);
    return newText;
  };

  return (
    <div className="cancel-subscription-element-step">
      <div className="cancel-subscription-element-step-container">
        <div className="cancel-subscription-element-step-header">
          <h2>{getTextByKey("subscription-cancel-confirmation")}</h2>
        </div>
        <div className="cancel-subscription-element-step-body">
          <div className="cancel-subscription-element-side-section top">
            {parse(
              replaceText(getTextByKey("cancel-your-subscription-step3-text"))
            )}
          </div>
        </div>
        <div className="cancel-subscription-element-step-actions">
          <Button
            className="new-button"
            blank
            onClick={() => setShowElement(false)}
          >
            {getTextByKey("close")}
          </Button>
        </div>
      </div>
    </div>
  );
};
